import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormsModule, UntypedFormBuilder } from '@angular/forms';
import { parseISO } from 'date-fns';
import { Subscription } from 'rxjs';
import { HxSpendService, HxUiLabelPipe, SpendingFullModel } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { DatePipe, NgIf } from '@angular/common';

@Component({
    selector: 'app-spend-show',
    templateUrl: './spend-show.component.html',
    styleUrls: ['./spend-show.component.css'],
    imports: [RouterLink, NgIf, FormsModule, DatePipe, TranslocoPipe, HxUiLabelPipe]
})
export class SpendShowComponent implements OnInit, OnDestroy {
  id: number;
  isLoading = {
    invoice: false,
  };
  spend?: SpendingFullModel;
  now: Date;
  note = '';
  isDateEqual = false;
  isPaid = false;
  private paidDate: Date;
  private sub: Subscription;

  constructor(
    private aRoute: ActivatedRoute,
    private spendService: HxSpendService,
    private toastr: ToastrService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private tr: TranslocoService
  ) { }

  ngOnInit() {
    this.sub = this.aRoute.params.subscribe(params => {
      this.id = params['id'] || null;
      this.getData();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private getData() {
    if (this.id) {
      this.spend = undefined;
      this.isLoading.invoice = true;

      this.spendService.getSpendById(this.id).then(result => {
        this.spend = result;
        this.isLoading.invoice = false;

        if (result.paid) {
          this.paidDate = parseISO(result.paid);
          this.now = new Date();
          this.isDateEqual = this.paidDate.getTime() === Date.parse(this.now.toDateString());
        }
        this.isPaid = result.paid !== undefined;
      });
    }
  }

  cancel() {
    this.router.navigate(['../../'], {
      relativeTo: this.aRoute
    });
  }

  onSubmitForm() {
    if (this.isPaid && this.isDateEqual) {
      const successText = this.tr.translate('spend-shop.ts.cancelSuccess');

      this.spendService.spendPaidCancelled(this.id).then(() => {
        this.toastr.success(successText);
        this.router.navigate(['../../'], {
          relativeTo: this.aRoute
        });
      }, err => this.errorHandler(err.error));
    } else {
      const obj = this.formBuilder.group({note: this.note}).getRawValue();
      const successText = this.tr.translate('spend-show.ts.paidSuccess');

      this.spendService.spendPaid(this.id, obj).then(() => {
        this.toastr.success(successText);
        this.router.navigate(['../../'], {
          relativeTo: this.aRoute
        });
      }, err => this.errorHandler(err.error));
    }
  }

  private errorHandler(err: any) {
    if (err && err.code) {
      if (err.code === 106) {
        this.showToastr(err.uiMessages);
      } else {
        this.toastr.warning(`${err.message}`);
      }
    }
  }

  private showToastr(msg) {
    for (let index = 0; index < msg.length; index++) {
      const element = msg[index];
      const field = `${element.field}`;
      const message = `${field}.${element.message}`;
      this.toastr.error(message);
    }
  }
}
